import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { MessageKey } from '../i18n';
import { TranslatedText } from './TranslatedText';

interface StatCardProps {
  value: string;
  labelKey: MessageKey;
  labelParams?: Record<string, string | number>;
}

const StyledStatCard = styled(Box)(({ theme }) => {
  const palette = theme.vars?.palette ?? theme.palette;
  const surface = palette.surface ?? {
    panelBorder: palette.divider,
    shadow: 'none',
  };

  return {
    height: '100%',
    borderRadius: theme.shape.surface,
    border: `1px solid ${surface.panelBorder}`,
    backgroundColor: palette.background.paper,
    padding: theme.spacing(1.75),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: theme.spacing(0.75),
    transition: theme.transitions.create(['border-color', 'box-shadow'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      borderColor: palette.primary.light,
      boxShadow: surface.shadow,
    },
  };
});

const StatValue = styled(Typography)(({ theme }) => ({
  color: theme.vars?.palette.text.primary ?? theme.palette.text.primary,
  fontWeight: 700,
  letterSpacing: '-0.015em',
  lineHeight: 1.1,
}));

export function StatCard({ value, labelKey, labelParams }: StatCardProps) {
  return (
    <StyledStatCard>
      <StatValue variant="h4">{value}</StatValue>
      <TranslatedText messageKey={labelKey} params={labelParams} variant="body2" color="text.secondary" />
    </StyledStatCard>
  );
}
